(() => {
  const histogramSelector = '.jm-histogram-row[role="button"]';

  const localiseReviewControls = (root = document) => {
    root.querySelectorAll(histogramSelector).forEach((row) => {
      const rating = row.querySelector('.jm-histogram-row__rating')?.textContent.trim();
      const stars = row.querySelector('.jm-star-rating[role="img"]');

      // Let the button derive its accessible name from the visible values.
      // Judge.me's generated English aria-label does not contain those values
      // in the same order and fails WCAG label-in-name checks.
      row.removeAttribute('aria-label');

      if (rating && stars) {
        stars.setAttribute('aria-label', `${rating} von 5 Sternen`);
      }
    });
  };

  const start = () => {
    localiseReviewControls();

    const observer = new MutationObserver((mutations) => {
      if (
        mutations.some((mutation) =>
          Array.from(mutation.addedNodes).some(
            (node) =>
              node.nodeType === Node.ELEMENT_NODE &&
              (node.matches?.(histogramSelector) || node.querySelector?.(histogramSelector)),
          ),
        )
      ) {
        localiseReviewControls();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
